import { InputTag } from 'mixs/base/input_mixin';
import {
  GOTO_COMMENT_FORM,
  APPROVAL_CLICK_REQUIRE
} from 'apps/events';
import RiotEventManager   from 'utilities/riot/event_manager';
export class ToWhom extends InputTag {
  eventManager: RiotEventManager;
  public init() {
    super.init();
    this.watch();
    this.eventManager = new RiotEventManager(this)
    this.eventManager.customEvent(APPROVAL_CLICK_REQUIRE, (e) => {this.requireApproval(e)});
  }
  onClickTab(e){
    let comment_scene = e.target.getAttribute('data-id');
    this.dispatch({comment_scene: comment_scene});
  }
  onClickAll(){
    let newVal = { s: { all: '1' } };
    this.dispatch(newVal);
  }
  onClickPartly(){
    let newVal = { s: { all: '0' } };
    this.dispatch(newVal);
  }
  onClickTo(e){
    let scope = e.target.value;
    let params = { ra: { seller: '0', sales_manager: '0', exective: '0' } };
    params.ra[scope] = '1'
    this.dispatch(params);
  }
  onChangeWho(e){
    let who = e.target.name.match(/\[(.+)\]/)[1]
    let newVal = { s: {} };
    newVal['s'][who] = e.target.checked ? '1' : '0'
    this.dispatch(newVal);
  }
  onChangeSalesManagers(e){
    let inputs = this.querySelectorAll('input[name="sales_managers[]"]')
    let sales_managers = {};
    for(let i = 0; i < inputs.length; i++){
      let input = <HTMLInputElement>inputs[i];
      let user_id = input.value + '';
      if(!sales_managers[user_id]){sales_managers[user_id] = {}}
      sales_managers[user_id]['checked'] = input.checked
    }
    this.dispatch({ sales_managers: sales_managers });
  }
  onChangeExectivess(e){
    let inputs = this.querySelectorAll('input[name="exectives[]"]')
    let exectives = {};
    for(let i = 0; i < inputs.length; i++){
      let input = <HTMLInputElement>inputs[i];
      let user_id = input.value + '';
      if(!exectives[user_id]){exectives[user_id] = {}}
      exectives[user_id]['checked'] = input.checked
    }
    this.dispatch({ exectives: exectives });
  }
  requireApproval(e){
    let params = { ra: { seller: '0', sales_manager: '0', exective: '0' } };
    let scope = e.detail.scope;
    params.ra[scope] = true;
    params['comment_scene'] = "require_approval";
    this.dispatch(params);
  }
}

riot.mixin('inputs.complex.to-whom', ToWhom as riot.TagMixin)
